import { render, staticRenderFns } from "./CarouselSection.vue?vue&type=template&id=619f0b9e&scoped=true&v-if=itemsCount&"
import script from "./CarouselSection.vue?vue&type=script&lang=js&"
export * from "./CarouselSection.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSection.vue?vue&type=style&index=0&id=619f0b9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619f0b9e",
  null
  
)

export default component.exports